import React from 'react'
import clsx from 'clsx'
import kebabCase from 'lodash.kebabcase'
import { Card } from '@/components/molecules/Card/Card'
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink'
import { Paragraph } from '@/components/atoms/MarkdownElements/MarkdownElements'
import { CollectionProps } from './types'
import * as styles from './CollectionSection.module.css'

export function CollectionSection({ title, text, items, is_wider = false }: CollectionProps) {
  return (
    <section
      className="flex flex-col mx-auto items-center p-24 netbook:px-90 netbook:py-64 max-w-screen-desktop"
      id={kebabCase(title)}
    >
      {title && (
        <h1 className="text-headingL-mobile netbook:text-headingL font-bold font-poppins text-center text-text-dark-900 mb-16 tablet:mb-24">
          {title}
        </h1>
      )}
      {text && (
        <Paragraph className="text-center text-text-dark-900 text-bodyL mb-40 tablet:max-w-xl tablet:mb-64">
          {text}
        </Paragraph>
      )}
      <div className={clsx(styles.collectionItemsWrapper, 'tablet:flex tablet:flex-wrap ')}>
        {items?.map((item) =>
          item.embed_video_url ? (
            <Card
              key={item._uid}
              {...item}
              wide={is_wider}
              secondary
              className={clsx('tablet:w-1/2 !mb-28', is_wider ? 'netbook:w-1/2' : 'netbook:w-1/3')}
            />
          ) : (
            <CustomLink
              {...item?.link[0]}
              className={clsx('tablet:w-1/2 !mb-28', is_wider ? 'netbook:w-1/2' : 'netbook:w-1/3')}
            >
              <Card key={item._uid} {...item} wide={is_wider} secondary className="!w-full last:mb-28 " />
            </CustomLink>
          )
        )}
      </div>
    </section>
  )
}
